import Phaser from 'phaser';
import { DEPTH } from '../core/Config';

export class NPCSprite extends Phaser.Physics.Arcade.Sprite {
  private animationBase: string;
  private usesSheet: boolean;

  constructor(scene: Phaser.Scene, x: number, y: number, texture: string) {
    const sheetKey = scene.textures.exists(`${texture}_sheet`) ? `${texture}_sheet` : texture;
    super(scene, x, y, sheetKey);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.animationBase = texture;
    this.usesSheet = scene.textures.exists(`${texture}_sheet`);
    this.setDepth(DEPTH.ACTOR + y);
    this.setOrigin(0.5, 1);
    this.setData('lastDirection', 'down');
    this.playIdle();
  }

  updateFacing(vx: number, vy: number) {
    let direction: 'left' | 'right' | 'up' | 'down' = 'down';
    if (Math.abs(vx) > Math.abs(vy)) direction = vx < 0 ? 'left' : 'right';
    else if (Math.abs(vy) > 0) direction = vy < 0 ? 'up' : 'down';
    this.setData('lastDirection', direction);
    this.setFlipX(!this.usesSheet && direction === 'left');
    if (this.usesSheet) {
      const animKey = `${this.animationBase}-walk-${direction}`;
      if (this.scene.anims.exists(animKey) && this.anims.currentAnim?.key !== animKey) this.play(animKey, true);
    }
    this.setDepth(DEPTH.ACTOR + this.y);
  }

  playIdle() {
    if (!this.active || !this.scene || !this.anims) return;
    const direction = this.getData('lastDirection') ?? 'down';
    this.setFlipX(!this.usesSheet && direction === 'left');
    if (this.usesSheet) {
      const animKey = `${this.animationBase}-idle-${direction}`;
      if (this.scene.anims.exists(animKey)) this.play(animKey, true);
    }
  }
}
